export const calculateWorkPrice = (workPrice: number, usage: number): number => (workPrice / 100) * usage;
